import type { WidgetPreset } from "../types";
import templateHtml from "./template.html?raw";

export const NEON_SIGN: WidgetPreset = {
  id: "neon-sign",
  label: "Neon Sign ✨",
  defaultWidth: 256,
  defaultHeight: 96,
  html: templateHtml,
};
